import Cookies from "universal-cookie";

export const setLoginCookies = data => {
  var cookies = new Cookies();
  cookies.set("access-levels", JSON.stringify(data.userAccess), { path: "/" });
  cookies.set("access-token", data.token, { path: "/" });
  cookies.set("user-Fname", data.firstName, { path: "/" });
  cookies.set("user-Lname", data.lastName, { path: "/" });
};

export const removeLoginCookies = () => {
  var cookies = new Cookies();
  cookies.remove("access-levels");
  cookies.remove("access-token");
  cookies.remove("user-Fname");
  cookies.remove("user-Lname");
};

export const getCookie = key => {
  var cookies = new Cookies();
  return cookies.get(key);
};

export const authHeader = () => {
  var cookies = new Cookies();
  let token = cookies.get("access-token");
  if (token) {
    return {
      // return authorization header with jwt token
      Authorization: "Bearer " + token
    };
  } else {
    return {};
  }
};

export const getAccess = (module, page) => {
  let accessInfo = getCookie("access-levels");
  if (accessInfo && accessInfo.length > 0) {
    let results = accessInfo.filter(access => {
      return (
        access.ModuleName.toLowerCase() === module.toLowerCase() &&
        access.PageName.toLowerCase() === page.toLowerCase()
      );
    });
    if (results && results.length > 0) return true;
    else return false;
  } else return false;
};

export const sortArrayByRegionName = data => {
  const caseInsensitiveSort = (a, b) =>
    a.RegionName.localeCompare(b.RegionName, undefined, {
      sensitivity: "base"
    });
  data.sort(caseInsensitiveSort);
};

export const sortArrayByLabel = (data) => {
  const caseInsensitiveSort = (a, b) =>
    a.label.localeCompare(b.label, undefined, {
      sensitivity: "base",
      numeric: true
    });
  data.sort(caseInsensitiveSort);
};
